import { UIActionTypes } from "./constants";

const initialState = {
  loading: false,
  ui: {},
  user: {},
  chatrooms: [],
  currentRequest: { services: [] },
  customer: {
    generalInformation: {},
    bodyInformation: {},
    preferences: {},
    documents: [],
  },
  currentRequestLoading: false,
    // Why the open request failed to load (null while it loads or loaded), and a
    // counter the detail's Retry bumps so the Chat page fetches it again.
    currentRequestError: null as string | null,
    requestReload: 0,
  image: null,
  awaitingSupervisorList: [],
  selectedAwaitingSupervisorItem: null,
  messages: [],
  selectedRoom: null,
  locallySendMessages: {},
  locallySendMessagesRecipients: {},
  activeUsers: [],
  vox: {
    calling: null, //'CALL' | 'RING' | null
    currentCall: null,
    sdk: null,
    callType: null, // 'VOICE'|'VOIP'|'VIDEO',
    inCall: false,
    muteMicrophone: false,
    cameraEnabled: false,
    localStream: null,
    remoteStream: null,
  },
    call: {
      currentCall: null,
      callStatus: null, // 'RINGING' | 'ACCEPTED' | 'CONNECTED' | null
      chimeCredentials: null,
      joinedChimeMeetingId: null, // Track which meeting we've already joined
      localStream: null,
      remoteStream: null,
      localTileId: null,
      remoteTileId: null,
      muteMicrophone: false,
      cameraEnabled: false,
      callStartTime: null, // Call başlangıç zamanı (duration hesaplama için)
      pendingCalls: [],
      activeCalls: [],
      callHistory: [],
      // Outgoing call state (Agent -> Customer or Agent -> Agent)
      outgoingCall: null, // { id, callType, receiver, customerReached, isAgentToAgent }
      isOutgoingCallRinging: false,
    },
};
const uiReducer = (
  state: any = initialState,
  action: { type: string; payload?: any }
): any => {
  switch (action.type) {
    case "UPDATE":
      return {
        ...state,
        ...action.payload,
      };
    case "VOX_UPDATE":
      return {
        ...state,
        vox: {
          ...state.vox,
          ...action.payload,
        },
      };
    case "CALL_UPDATE":
      return {
        ...state,
        call: {
          ...state.call,
          ...action.payload,
        },
      };
    case UIActionTypes.UPDATE_REQUEST:
      return {
        ...state,
        currentRequest: {
          ...action.payload,
        },
      };
    case UIActionTypes.CLEAR_REQUEST:
      return {
        ...state,
        currentRequest: null,
        // A closed request takes its load error with it.
        currentRequestError: null,
      };
  }
  return state;
};

export default uiReducer;
